module.exports = __webpack_public_path__ + "img/ic_16_points.2006d803.svg";